import { Role } from '../../models/enums/role.enum';

export const formatRole = (role: Role): string => {
  if (!role) return 'Sin rol';

  switch (role) {
    case Role.God:
      return 'Administrador';
    case Role.Student:
      return 'Estudiante';
    case Role.Teacher:
      return 'Profesor';
    case Role.Affiliate:
      return 'Afiliado';
    case Role.Tutor:
      return 'Tutor';
    case Role.ContentDirector:
      return 'Director de Contenidos';
    default:
      return role;
  }
};
